<div class="card mb-3 border-0">
  <div *ngIf="!allowEditing">
    <div *ngIf="member$ | async as member">
      <div class="">
        <label class="mb-0">{{ 'account.details.dob' | translate }}</label>
        <div class="d-flex bg-details p-2 m-0 mt-1 rounded">
          <span class="icon material-icons" aria-hidden="true">date_range</span>
          <span class="ms-3 text-white">{{ member.DOB | date : 'd MMM, yyy' }}</span>
        </div>
      </div>
      <div *ngIf="member.MobileNumber">
        <label class="mb-0 personal-info">{{ 'account.details.contact.no' | translate }}</label>
        <div class="d-flex bg-details p-2 m-0 mt-1 rounded">
          <span class="icon material-icons" aria-hidden="true">phone</span>
          <span class="ms-3 text-white">{{ member.MobileNumber }}</span>
        </div>
      </div>
      <div>
        <label class="mb-0 personal-info">{{ 'account.details.email' | translate }}</label>
        <div class="d-flex bg-details p-2 m-0 mt-1 rounded">
          <span class="icon material-icons" aria-hidden="true">email</span>
          <span class="ms-3 text-white">{{ member.EmailAddress1 }}</span>
        </div>
      </div>
      <div>
        <label class="mb-0 personal-info">{{ 'account.details.home.address' | translate }}</label>
        <div class="d-flex bg-details p-2 m-0 mt-1 rounded">
          <span class="icon material-icons d-inline-block" aria-hidden="true">location_on</span>
          <span class="ms-3 text-white d-inline-block">
            <div>{{ member.AddressName }}</div>
            <div>{{ member.Street }}</div>
            <div>{{ member.Town }}</div>
            <div>{{ member.Country }}</div>
            <div>{{ member.PostCode }}</div>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #loadingRef>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
